import React from "react";
import { getMessaging, getToken } from "firebase/messaging";
import { initializeApp } from "firebase/app";
import Server from "./Server.js";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Navigate, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Sidebar } from "primereact/sidebar";
import { InputText } from "primereact/inputtext";
import axios from "axios";
import { Carousel } from "primereact/carousel";
import { Divider } from "primereact/divider";

const firebaseConfig = new Server().getFirebaseConfig();
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

class LoginBox extends React.Component {
  constructor(props) {
    super(props);
    this.toast = React.createRef();
    this.passwordBtn = React.createRef();
    this.loginBtn = React.createRef();

    this.Server = new Server();
    this.state = {
      appData: this.props.appData,
      username: "",
      placeSet: "",
      Logo: "",
      showAd: false,
      Tel: "",
      place: (this.Server.getSystem() && this.Server.getSystem().place) || this.Server.getPlace(),
      ShowLoading: false,
      showWebElements: false,
      chacheVersion: 2,
      ads: {},
      systems: [],
      absoluteUrl: this.Server.getAbsoluteUrl(),
      systemId: this.Server.getSystem() ? this.Server.getSystem().id : null
    };
  }

  convertNum(str) {
    var persianNumbers = [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g,
      ],
      arabicNumbers = [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g,
      ];

    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return str;
  }

  loginRaymand(username, password) {
    let that = this;
    axios
      .get(
        `https://r-bank.ir/TransferApi/BranchInfo?BrCode=${this.state.place}`,
        {
          headers: {
            "Access-Control-Allow-Headers": "*",
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Im5hbWUiLCJyb2xlIjoiTW9iaWxlQWRtaW4iLCJuYmYiOjE2MzIwMzU0ODYsImV4cCI6MTYzMjAzOTA4NiwiaWF0IjoxNjMyMDM1NDg2fQ.awclj9AqrlJjyLVE9UVvrCo2a9CdGgHxUjeUOUW8eqI",
          },
        }
      )
      .then((response) => {
        const BrIP = response.data.BrWebResCore
          ? response.data.BrWebResCore.split(":")[1].split("//")[1]
          : null;
        const PortNo = response.data.BrWebResCore
          ? response.data.BrWebResCore.split(":")[2].split("/")[0]
          : null;
        axios
          .post(that.state.absoluteUrl + "MainApi/raymand_api" + "", {
            port: PortNo,
            ip: BrIP,
            method: "post",
            path: "/api/MobileApi/Login",
            body: JSON.stringify({
              Password: password,
              User: username,
            }),
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            const res = response.data.result;
            
            if(response.data.error){
              that.toast.current.show({
                severity: "error",
                summary: (
                  <div className="iranyekanwebmedium">
                    خطا در برقراری ارتباط
                  </div>
                ),
                detail: <div className="iranyekanwebmedium">{response.data.error}</div>,
                life: 4000,
              });
              that.setState({
                ShowLoading: false,
              });
              return;
            }  
            if (!res.mobile) {
              const msg = res.message || "پارامترهای ورودی صحیح نیست";
              that.toast.current.show({
                severity: "error",
                summary: (
                  <div className="iranyekanwebmedium">
                    خطا در برقراری ارتباط
                  </div>
                ),
                detail: <div className="iranyekanwebmedium">{msg}</div>,
                life: 4000,
              });

              that.setState({
                ShowLoading: false,
              });
              return;
            }
            if (res.mobile) {
              let SCallBack = function (response) {
                if (response) response = response[0].children;
                else {
                  that.toast.current.show({
                    severity: "error",
                    summary: (
                      <div className="iranyekanwebmedium">
                        خطا در برقراری ارتباط
                      </div>
                    ),
                    detail: (
                      <div className="iranyekanwebmedium">
                        پارامترهای ورودی صحیح نیست
                      </div>
                    ),
                    life: 4000,
                  });
                  that.setState({
                    ShowLoading: false,
                  });
                  return;
                }
                let account = "";
                for (let i = 0; i < response.length; i++) {
                  if (response[i].name == "A_Accx") {
                    if (response[i].value != "") account = response[i].value;
                  }
                }
                if (account) {
                  that.Server.send(
                    "MainApi/getuser",
                    {
                      username: res.mobile,
                      noPass: 1,
                      RaymandUser: username,
                      systemId: that.state.systemId,
                      app: true,
                    },
                    function (response) {
                      localStorage.setItem("api_token", response.data.token);
                      if (response.data.result && response.data.result.error) {
                        if(response.data.result.status !== "disabled"){
                          that.Server.send(
                            "MainApi/autoRegister",
                            {
                              username: res.mobile,
                              password: password,
                              address: "",
                              name: res.name,
                              RaymandUser: username,
                              systemId: that.state.systemId,
                            },
                            function (response) {
                              const variables = {
                                type: "LoginTrue",
                                username: username,
                                password: password,
                                ip: BrIP,
                                port: PortNo,
                                account: account,
                                place: that.state.place,
                                fullname:  res.name,
                                mobile: res.mobile,
                                appData: that.state.appData,
                                systemId: that.state.systemId,
                                tokenrb: res.tokenrb,
                                creditPrice: false,
                              };
                              that.props.dispatch({
                                ...variables,
                              });
                              that.setState({
                                ShowLoading: false,
                              });
                              setTimeout(() => {
                                that.props.AfterLogin(variables);
                                that.setNotificationToken(variables.mobile);
                              }, 0);
                            },
                            function (error) {}
                          );
                        }else{
                          that.toast.current.show({
                            severity: "error",
                            summary: (
                              <div className="iranyekanwebmedium">خطا در برقراری ارتباط</div>
                            ),
                            detail: (
                              <div className="iranyekanwebmedium">عدم دسترسی</div>
                            ),
                            life: 4000,
                          });
                          that.setState({
                            ShowLoading: false,
                          });
                        }
                      } else {
                        const variables = {
                          type: "LoginTrue",
                          username: username,
                          password: password,
                          ip: BrIP,
                          port: PortNo,
                          account: account,
                          place: that.state.place,
                          fullname:  res.name,
                          mobile: res.mobile,
                          appData: that.state.appData,
                          systemId: that.state.systemId,
                          tokenrb: res.tokenrb,
                          creditPrice: false,
                        };
                        that.props.dispatch({
                          ...variables,
                        });
                        setTimeout(() => {
                          that.setState({
                            ShowLoading: false,
                            ip: BrIP
                          });
                          that.props.AfterLogin(variables);
                          that.setNotificationToken(variables.mobile);
                        }, 0);
                      }
                    },
                    function (error) {
                      that.setState({
                        ShowLoading: false,
                      });
                      alert(error);
                    }
                  );
                }
              };
              let ECallBack = function (error) {
                that.setState({
                  ShowLoading: false,
                });
                alert(error);
              };
              var param =
                '{CommandNo : "31" , AccountNo: "' +
                username +
                '",Param1: "' +
                password +
                '" }';
              that.Server.sendRaymand(
                "" + BrIP + "/MobileBank.aspx/MobileBankSp",
                param,
                SCallBack,
                ECallBack,
                {
                  ip:BrIP,
                  /*port:PortNo*/
                }
              );
            }
          })
          .catch((error) => {
          });
      })
      .catch((error) => {
      });
  }

  LoginPress(Again) {
    let that = this;
    let username = this.convertNum(this.state.username);
    let password = this.convertNum(this.state.password);
    if (!username) {
      return;
    }
    if (
      (username && username.length > 9 && !this.props.loginBank) || (username && isNaN(username)  && !this.props.loginBank)
    ) {
      this.LoginAnia(username);
      return;
    }
    this.setState({
      ShowLoading: true,
    });
    this.loginRaymand(username, password);
  }
  LoginAnia(username) {
    let that = this;
    if (!username) {
      return;
    }
    username = this.convertNum(username.trim());
    let password = this.convertNum(this.state.password);
    this.setState({
      ShowLoading: true,
    });
    let SCallBack = function (response) {
      if (!response.data.token) {
        that.toast.current.show({
          severity: "error",
          summary: (
            <div className="iranyekanwebmedium">خطا در برقراری ارتباط</div>
          ),
          detail: (
            <div className="iranyekanwebmedium">{response.data.result[0]}</div>
          ),
          life: 4000,
        });
        that.setState({
          ShowLoading: false,
        });
        return;
      }

      localStorage.setItem("systemId", that.state.systemId || null);
      localStorage.setItem("api_token", response.data.token);
      const variables = {
        type: "LoginTrue",
        LoginAnia: true,
        username: null,
        password: password,
        mobile: username,
        fullname: response.data.result[0].name || username,
        appData: that.state.appData,
        creditPrice: response.data.result[0].creditPrice || false,
        systemId: that.state.systemId,
      };
      that.props.dispatch({
        ...variables,
      });
      setTimeout(() => {
        that.setState({
          ShowLoading: false,
        });
        that.props.AfterLogin(variables);
        that.setNotificationToken(username);
      }, 0);
    };
    let ECallBack = function (error) {
      that.setState({
        HasError: "رمز عبور اشتباه است",
      });
      console.log(error);
    };
    this.Server.send(
      "MainApi/getuser",
      {
        username: username,
        password: password,
        systemId: this.state.systemId,
        app: true,
      },
      SCallBack,
      ECallBack
    );
  }
  setNotificationToken(mobile) {
    let that = this;
    var username = mobile
      ? mobile.charAt(0) == "0"
        ? mobile.substr(1)
        : mobile
      : mobile;
    username = username ? username.substr(username.length - 10, 10) : null;
    getToken(messaging, {
      vapidKey:
        "BGY4PYqXBZnU6pQuU3X30Qx1NqptOL89EcnUHNtgbA7fyZK99i8g05YNEsJhZiZIZ2wZSH5iba_msKNsxSqhOcc",
    })
      .then((currentToken) => {
        if (currentToken) {
          let SCallBack = function (response) {};
          let ECallBack = function (error) {};
          that.Server.send(
            "AdminApi/setNotificationToken",
            { token: currentToken },
            SCallBack,
            ECallBack
          );
        } else {
          //alert("111")
          console.log(
            "No registration token available. Request permission to generate one."
          );
        }
      })
      .catch((err) => {
        //alert(err)

        console.log("An error occurred while retrieving token. ", err);
      });
  }

   PassRecovery() {
    let that = this;
    if (
      !this.state.NationalCodeForRecovery ||
      !this.state.mobileForRecovery ||
      !this.state.UsernameForRecovery
    ) {
      return;
    }
    this.setState({
      ShowLoading: true,
    });
    let SCallBack = function (response) {
      that.setState({
        ShowLoading: false,
        visiblePassRecovery: false,
      });
      that.toast.current.show({
        severity: "success",
        summary: <div className="iranyekanwebmedium">بازیابی رمز عبور</div>,
        detail: <div className="iranyekanwebmedium">رمز عبور ارسال شد</div>,
        life: 4000,
      });
    };
    let ECallBack = function (error) {
      that.setState({
        ShowLoading: false,
      });
      alert(error);
    };
    const username = this.state.UsernameForRecovery;
    const NationalCode = this.state.NationalCodeForRecovery;
    const Mobile = this.state.mobileForRecovery;
    var param = `{CommandNo : 142 , AccountNo: ${username},Param1: "${NationalCode};${Mobile}"  }`;
    axios
      .get(
        `https://r-bank.ir/TransferApi/BranchInfo?BrCode=${this.state.place}`,
        {
          headers: {
            "Access-Control-Allow-Headers": "*",
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Im5hbWUiLCJyb2xlIjoiTW9iaWxlQWRtaW4iLCJuYmYiOjE2MzIwMzU0ODYsImV4cCI6MTYzMjAzOTA4NiwiaWF0IjoxNjMyMDM1NDg2fQ.awclj9AqrlJjyLVE9UVvrCo2a9CdGgHxUjeUOUW8eqI",
          },
        }
      )
      .then((response) => {
        const BrIP = response.data.BrWebResCore
          ? response.data.BrWebResCore.split(":")[1].split("//")[1]
          : null;
        that.Server.sendRaymand(
          "/MobileBank.aspx/MobileBankSp",
          param,
          SCallBack,
          ECallBack,
          {
            ip:BrIP,
            /*port:PortNo*/
          }
        );
      })
  }
  render() {
    return (
      <div
        style={
          this.props.inForceLogin
            ? {
                background: "#fff",
                padding: 14,
                borderRadius: 14,
              }
            : {
                background: "#fff",
                padding: 14,
                borderRadius: 14,
                width: "100%",
              }
        }
      >
        <Toast
          ref={this.toast}
          position="top-right"
          style={{ fontFamily: "iranyekanwebmedium", textAlign: "right" }}
        />

        {this.state.appData.multiSystem &&
        this.state.systems.length > 1 &&
        this.state.showChangeSystem ? (
          <div
            style={{
              marginTop: 35,
              display: "flex",
              justifyContent: "space-around",
              width: "100%",
              position: "relative",
            }}
          >
            <label
              className="iranyekanwebmedium sarv-title1"
              style={{ position: "absolute", right: 5, top: -30 }}
            >
              سیستم مورد نظر خود را انتخاب کنید
            </label>
            <select
              style={{
                width: "100%",
                height: 40,
                textAlign: "center",
                direction: "rtl",
              }}
              placeholder="انتخاب سیستم"
              className="form-control iranyekanwebmedium"
              id="systemId"
              name="systemId"
              value={this.state.systemId}
              onChange={(event) => {
                this.setState({ systemId: event.target.value });
                if (this.props.AfterChangeSystem) {
                  this.props.AfterChangeSystem(event.target.value);
                }
              }}
            >
              {this.state.systems.map(function (item, index) {
                return (
                  <option className="iranyekanwebmedium" value={item._id}>
                    {item.name}
                  </option>
                );
              })}
            </select>
          </div>
        ) : (
          this.state.systems.length > 1 && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              className="sarv-title1"
            >
              <a
                onClick={() => {
                  this.setState({
                    showChangeSystem: !this.state.showChangeSystem,
                  });
                }}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span style={{ fontSize: 12 }}>تغییر سیستم</span>
                <i className="fas fa fa-cogs" style={{ marginLeft: 5 }} />
              </a>
              <p style={{ fontSize: 18, fontWeight: "normal" }}>
                {this.state.selectedSystemName}
              </p>
            </div>
          )
        )}
        {!this.props.onlyShowSystemBox && (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: 40,
                zIndex: 1000,
              }}
            >
              <img
                src={`./icons/${this.state.appData?.lName}/logo.png`}
                style={{ width: 80 }}
              />
            </div>

            <div className="p-float-label" style={{ textAlign: "right" }}>
              <InputText
                autocomplete="off"
                style={{
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                  textAlign: "center",
                }}
                type="text"
                id="username"
                tabIndex={1}
                value={this.state.username}
                name="username"
                onChange={(e) => this.setState({ username: e.target.value })}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    this.passwordBtn.current.focus();
                  }
                }}
                required
              />
              <label
                className="iranyekanwebmedium "
                style={{ position: "absolute", right: 5 }}
              >
                نام کاربری
              </label>
            </div>
            <div
              className="p-float-label"
              style={{ marginTop: 30, textAlign: "right" }}
            >
              <InputText
                autocomplete="off"
                style={{
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                  textAlign: "center",
                }}
                className="iranyekanwebmedium block "
                type="password"
                id="password"
                tabIndex={2}
                ref={this.passwordBtn}
                value={this.state.password}
                name="password"
                onChange={(e) => this.setState({ password: e.target.value })}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    this.loginBtn.current.focus();
                  }
                }}
                required
              />
              <label
                className="iranyekanwebmedium "
                style={{ position: "absolute", right: 5 }}
              >
                رمز عبور
              </label>
            </div>
            <div
              style={{
                marginTop: 35,
                display: "none",
                justifyContent: "flex-end",
                width: "100%",
                position: "relative",
                borderBottom: "3px dotted #000",
              }}
            >
              <label
                htmlFor="ShowPriceAftLogin"
                className="p-checkbox-label iranyekanwebmedium"
                style={{ paddingRight: 5, height: 30 }}
              >
                {" "}
                ذخیره نام کاربری
              </label>
              <Checkbox
                style={{ marginRight: 10 }}
                inputId="ShowPriceAftLogin"
                value={this.state.ShowPriceAftLogin}
                checked={this.state.ShowPriceAftLogin}
                onChange={(e) =>
                  this.setState({ ShowPriceAftLogin: e.checked })
                }
              ></Checkbox>
            </div>

            <div
              style={{
                marginTop: 30,
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Button
                className="iranyekanwebmedium  p-button-lg p-button-danger"
                loading={this.state.ShowLoading}
                disabled={this.state.ShowLoading}
                tabIndex={3}
                ref={this.loginBtn}
                onClick={() => {
                  this.LoginPress();
                }}
                style={{
                  textAlign: "center",
                  borderRadius: 8,
                  padding: 8,
                  width: "50%",
                }}
              >
                <span className="iranyekanwebmedium" style={{ width: "100%" }}>
                  ورود
                </span>
              </Button>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 30,
              }}
            >
              <div>
                <Button
                  onClick={() => {
                    this.setState({
                      visiblePassRecovery: true,
                    });
                  }}
                  className="iranyekanwebmedium  p-button-sm p-button-danger p-button-outlined"
                >
                  <span
                    className="iranyekanwebmedium"
                    style={{ fontSize: 16, fontWeight: "bold" }}
                  >
                    بازیابی رمز عبور
                  </span>
                </Button>
              </div>
              {this.state.appData && this.state.appData.hasBank && (
                <div>
                    <Link
                      className="p-button p-component iranyekanwebmedium  p-button-sm p-button-info p-button-outlined"
                      style={{padding:6}}
                      to={`${process.env.PUBLIC_URL}/New`}
                    >
                      {" "}
                      <span className="iranyekanwebmedium">
                        درخواست افتتاح حساب
                      </span>{" "}
                    </Link>
                </div>
              )}
            </div>
            <div>
              <Divider />
              <p style={{ textAlign: "right" }}>همکاران ما</p>
              <Carousel
                numVisible={1}
                numScroll={1}
                className="custom-carousel"
                circular
                value={[
                  {
                    src: "https://img.inax.ir/2019/06/cropped-inax_logo-1.png",
                  },
                  {
                    src: "https://r-bank.ir/img/raymand.jpg",
                  },
                ]}
                autoplayInterval={3000}
                itemTemplate={(item) => {
                  return (
                    <div>
                      <img
                        src={item.src}
                        style={{ width: "100%", height: 80 }}
                      />
                    </div>
                  );
                }}
              />
            </div>
          </div>
        )}

        <Sidebar
          visible={this.state.visiblePassRecovery}
          onHide={() =>
            this.setState({
              visiblePassRecovery: false,
            })
          }
        >
          <div
            className="p-float-label"
            style={{ marginTop: 30, textAlign: "right" }}
          >
            <InputText
              autocomplete="off"
              style={{
                fontFamily: "iranyekanwebmedium",
                width: "100%",
                textAlign: "center",
              }}
              className="iranyekanwebmedium block "
              tabIndex={100}
              type="number"
              id="username"
              value={this.state.UsernameForRecovery}
              name="username"
              onChange={(e) =>
                this.setState({ UsernameForRecovery: e.target.value })
              }
              required
            />
            <label
              className="iranyekanwebmedium sarv-title1"
              style={{ position: "absolute", right: 5 }}
            >
              نام کاربری
            </label>
          </div>
          <div
            className="p-float-label"
            style={{ marginTop: 50, textAlign: "right" }}
          >
            <InputText
              autocomplete="off"
              style={{
                fontFamily: "iranyekanwebmedium",
                width: "100%",
                textAlign: "center",
              }}
              className="iranyekanwebmedium block "
              type="number"
              tabIndex={101}
              id="username"
              value={this.state.mobileForRecovery}
              name="username"
              onChange={(e) =>
                this.setState({ mobileForRecovery: e.target.value })
              }
              required
            />
            <label
              className="iranyekanwebmedium sarv-title1"
              style={{ position: "absolute", right: 5 }}
            >
              شماره موبایل
            </label>
          </div>
          <div
            className="p-float-label"
            style={{ marginTop: 50, textAlign: "right" }}
          >
            <InputText
              autocomplete="off"
              style={{
                fontFamily: "iranyekanwebmedium",
                width: "100%",
                textAlign: "center",
              }}
              className="iranyekanwebmedium block "
              id="NationalCodeForRecovery"
              value={this.state.NationalCodeForRecovery}
              name="NationalCodeForRecovery"
              tabIndex={102}
              onChange={(e) =>
                this.setState({ NationalCodeForRecovery: e.target.value })
              }
              required
            />
            <label
              className="iranyekanwebmedium sarv-title1"
              style={{ position: "absolute", right: 5 }}
            >
              کد ملی
            </label>
          </div>

          <div
            style={{
              marginTop: 50,
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <Button
              loading={this.state.ShowLoading}
              disabled={this.state.ShowLoading}
              className="iranyekanwebmedium  p-button-sm p-button-danger"
              style={{ width: "100%", fontSize: 16, fontWeight: "bold" }}
              onClick={() => {
                this.PassRecovery();
              }}
            >
              <span
                className="iranyekanwebmedium"
                style={{ width: "100%", fontSize: 16, fontWeight: "bold" }}
              >
                بازیابی رمز عبور
              </span>
            </Button>
          </div>
        </Sidebar>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    username: state.username,
    password: state.password,
    ip: state.ip,
    account: state.account,
    place: state.place,
    fullname: state.fullname,
    tokenrb: state.tokenrb,
    mobile: state.mobile,
    LoginAnia: state.LoginAnia,
    creditPrice: state.creditPrice,
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(LoginBox);
